import { ActionIcon, Box, Button, Group } from '@mantine/core'
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react'
import dayjs from 'dayjs'
import { useRef } from 'react'

export default function MonthNavigation({ month, onChange }: { month: string; onChange: (month: string) => void }) {
  const monthInputRef = useRef<HTMLInputElement>(null)

  const currentMonth = dayjs().format('YYYY-MM')
  const isCurrentMonth = month === currentMonth

  const handlePrevious = () => onChange(dayjs(`${month}-01`).subtract(1, 'month').format('YYYY-MM'))

  const handleNext = () => onChange(dayjs(`${month}-01`).add(1, 'month').format('YYYY-MM'))

  const handleCurrent = () => onChange(currentMonth)

  const handleOpenPicker = () => monthInputRef.current?.showPicker()

  const handlePick = (event: React.ChangeEvent<HTMLInputElement>) =>
    event.currentTarget.value && onChange(event.currentTarget.value)

  return (
    <Group gap={6}>
      <ActionIcon variant="default" size={36} onClick={handlePrevious} aria-label="Mois précédent">
        <IconChevronLeft size={20} />
      </ActionIcon>
      <ActionIcon variant="default" size={36} onClick={handleNext} aria-label="Mois suivant">
        <IconChevronRight size={20} />
      </ActionIcon>
      <Box pos="relative">
        {/* Both buttons are fixed width so the row keeps its shape whatever the month is named. */}
        <Button variant="default" tt="capitalize" w={150} onClick={handleOpenPicker}>
          {dayjs(`${month}-01`).format('MMMM YYYY')}
        </Button>
        <input
          ref={monthInputRef}
          type="month"
          value={month}
          onChange={handlePick}
          aria-hidden
          tabIndex={-1}
          style={{ position: 'absolute', inset: 0, opacity: 0, pointerEvents: 'none' }}
        />
      </Box>
      {!isCurrentMonth && (
        <Button variant="default" w={130} onClick={handleCurrent}>
          Aujourd'hui
        </Button>
      )}
    </Group>
  )
}
